import React, { useState, useEffect } from "react";
import "./vortex-download.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import StatusCard from "../addonstatus/StatusCard";
import useStatus from "../addonstatus/useStatus";

const defaultAddons = [
  {
    name: "Prison Addons",
    version: "Loading...",
    mcVersion: "Loading...",
    releaseDate: "Loading...",
    lastUpdate: "Loading...",
    downloads: "Loading...",
   changelog: [
"📜 Prison Addon v1.6.1.3",
"",

"🔄 UPDATE OVERVIEW",
"This update focuses on Bedrock compatibility, mine improvements, custom pickaxe upgrades, and overall addon stability.",

"",

"✨ ADDED",
"• Added support for the latest Minecraft Bedrock update",
"• Improved custom pickaxe system",
"• Added player name support on pickaxes",
"• Added blocks mined statistics tracking",
"• Added improvements to mine systems and progression",

"",

"⛏️ MINES UPDATE",
"• Improved mine performance and stability",
"• Added backend support for larger mine sizes",
"• Improved mine progression systems",
"• Optimized mine reset systems",

"",

"🪓 PICKAXE UPDATE",
"• Pickaxes now display player names",
"• Improved blocks mined tracking",
"• Improved custom pickaxe progression",
"• Backend optimizations for player pickaxe data",

"",

"🛠️ FIXES",
"• Fixed issues caused by recent Minecraft updates",
"• Fixed addon compatibility problems",
"• Fixed various reported bugs",
"• Improved data saving reliability",
"• General stability improvements",

"",

"⚙️ CHANGES",
"• Improved addon stability",
"• Optimized systems for smoother gameplay",
"• Performance improvements",
"• Backend optimizations",

"",

"⚠️ NOTES",
"• Replace all old addon files before updating",
"• Restart your world/server after updating",
"• Recommended for all users on the latest Bedrock version",

"",

"🚀 COMING SOON",
"• Bigger mine sizes",
"• Additional mine upgrades",
"• More progression systems",
"• More enchantments",
"• Additional customization options",
"• New GUI improvements",
"• More performance optimizations 👀"
],

    versionUrl:
      "https://raw.githubusercontent.com/RealModking/Vortex-Prison-addon/main/version.json",
    icon: "fa-gavel",
    description:
      "Advanced Minecraft Bedrock prison addons with mines, backpacks, auto sell, ranks, enchants, prestiges, crates, and more.",
    features: ["Auto sell", "Backpacks", "Enchants", "Ranks"],
    curseforge:
      "https://www.curseforge.com/minecraft-bedrock/scripts/prison-addon/download/8260017",
    mcpedl: "https://mcpedl.com/prison-addon",
    newdownloadlink: "https://vortexnetowrknew.co.uk/download/VNPrisonBP.zip"
  },
    {
    name: "SkyBlock Addon",
    version: "Loading...",
    mcVersion: "Loading...",
    releaseDate: "Loading...",
    lastUpdate: "Loading...",
    changelog: [
  "📜 SkyBlock Addon v1.0.0",
  "",],
    versionUrl: "https://raw.githubusercontent.com/RealModking/Vortex-Skyblock-addon/refs/heads/main/version.json",
    icon: "fa-bolt",
    description:
      "Start on your own floating island and expand your empire with challenges, generators, economy systems, and island upgrades.",
    features: [
      "Island Creation",
      "Challenges",
      "Generators",
      "Island Upgrades",
    ],
    curseforge: "#",
    mcpedl: "#",
    newdownloadlink: "https://vortexnetowrknew.co,uk/download/skyblock.zip"
  },

  {
    name: "Coming Soon",
    version: "Loading...",
    mcVersion: "Loading...",
    releaseDate: "Loading...",
    lastUpdate: "Loading...",
    changelog:[ "coming soon..."],
    versionUrl: null, // No version URL since it's not released yet
    icon: "fa-puzzle-piece",
    description:
      "A brand new Vortex Network addon is currently in development. Expect advanced gameplay systems, unique mechanics, improved performance, and exciting new content designed for Minecraft Bedrock Edition.",
    features: [
      "New Gameplay Systems",
      "Custom Features",
      "Performance Optimized",
      "More Information Soon",
    ],
    curseforge: "#",
    mcpedl: "#",
    newdownloadlink: "#"
  },
];

const Vortexdownload = () => {
  const { services, global } = useStatus();

  const [addons, setAddons] = useState(defaultAddons);
  const [selectedAddon, setSelectedAddon] = useState(defaultAddons[0]);
  


useEffect(() => {
  async function loadVersions() {
    const updatedAddons = await Promise.all(
      defaultAddons.map(async (addon) => {
        if (!addon.versionUrl) return addon;

        try {
          const res = await fetch(addon.versionUrl);
          const data = await res.json();

          return {
            ...addon,
            version: data.version,
            mcVersion: data.mcVersion,
            releaseDate: data.releaseDate,
            lastUpdate: data.lastUpdate,
            downloads: data.downloads || "Unknown",
          };
        } catch {
          return addon;
        }
      })
    );

    setAddons(updatedAddons);

    // 👇 only sync selected after load
    setSelectedAddon(updatedAddons[0]);
  }

  loadVersions();
}, []);

  return (
    <div className="page">

      {/* BACKGROUND GLOW */}
      <div className="glow glow1"></div>
      <div className="glow glow2"></div>

      <div className="container">

        {/* HERO */}
        <div className="hero">
          <div className="badge">
            <i className="fa-solid fa-shield-halved"></i>
            Vortex Network
          </div>

          <h1>Downloads & Network Status</h1>

          <p>
            Download the latest Vortex Network addons and view live
            service status updates.
          </p>
        </div>

        {/* MAIN GRID */}
        <div className="main-grid">

          {/* DOWNLOAD CARD */}
          <div className="download-card">

            <div className="addon-selector">
              <label>Select Addons</label>

              <select
                value={selectedAddon.name}
                onChange={(e) => {
                  const addon = addons.find(
                    (a) => a.name === e.target.value
                  );

                  if (addon) {
                    setSelectedAddon(addon);
                  }
                }}
              >
                {addons.map((addon, index) => (
                  <option key={index} value={addon.name}>
                    {addon.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="card-header">

              <div className="icon-box">
                <i className={`fa-solid ${selectedAddon.icon}`}></i>
              </div>

              <div>
                <h2>{selectedAddon.name}</h2>
                <span>Latest Version {selectedAddon.version}</span>
                <br />
                <span>Minecraft Bedrock Version {selectedAddon.mcVersion}</span>
                <br />
                <span>Release Date: {selectedAddon.releaseDate}</span>
                <br />
                <span>Last Update: {selectedAddon.lastUpdate}</span>
              </div>

            </div>
            <h2>Description</h2>
            <p className="description">
              {selectedAddon.description}
            </p>
            <h2>Features</h2>
            <div className="features">
              {selectedAddon.features.map((feature, i) => (
                <div className="feature" key={i}>
                  <i className="fa-solid fa-check"></i>
                  {feature}
                </div>
              ))}
            </div>

            <div className="submit-container">

              <button
                className="submit curseforge"
                onClick={() => {
                  const a = document.createElement("a");
                  a.href = selectedAddon.curseforge;
                  a.setAttribute("download", "");
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                }}
              >
                <i className="fa-solid fa-download"></i>
                CurseForge Download
              </button>
              <button
                className="submit newdownloadlink"
                onClick={() => {
                  const a = document.createElement("a");
                  a.href = selectedAddon.newdownloadlink;
                  a.setAttribute("download", "");
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                }}                
              >
                <i className="fa-solid fa-globe"></i>
                Official Site Download
              </button>
              <button
                className="submit mcpedl"
                onClick={() =>{
                  const a = document.createElement("a");
                  a.href = selectedAddon.mcpedl;
                  a.setAttribute("download", "");
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                }}
              >
                <i className="fa-solid fa-cube"></i>
                MCPEDL Download
              </button>         
            </div>
          </div>

          {/* STATUS CARD */}
          <div className="status-wrapper">

            <div className="status-header">

              <h2>
                <i className="fa-solid fa-server"></i>
                Network Status
              </h2>

              <div className={`global-status ${global.color}`}>
                {global.status}
              </div>

              <p>Last updated: {global.lastUpdated}</p>

            </div>

            <div className="cards">
              {services.map((service, i) => (
                <StatusCard
                  key={i}
                  title={service.name}
                  status={
                    service.info
                      ? `${service.status} (${service.info})`
                      : service.status
                  }
                  color={service.color}
                />
              ))}
            </div>
              <div className="addon-stats">

              {/*<div className="stat-card">
                <i className="fa-solid fa-download"></i>
                <span> <br />{selectedAddon.downloads} </span>
                <small>Downloads</small>
              </div>*/}

                <div className="stat-card">
                  <i className="fa-solid fa-calendar"></i>
                  <span> <br />{selectedAddon.lastUpdate}<br /></span>
                  <small> Last Update</small>
                </div>

              <div className="stat-card">
                  <i className="fa-solid fa-clock"></i>
                  <span><br />{selectedAddon.releaseDate}<br/> </span>
                  <small>Release Date</small>
                </div>

                <div className="stat-card">
                  <i className="fa-solid fa-circle-check"></i>
                  <span><br />Active </span>
                  <small>Status</small>
                </div>          
              </div>
              <div className="changelog-box">
                <h2 className="changelog-header">Changelog</h2>
                <ul className="changelog-list">
                  {selectedAddon.changelog.map((entry, index) => (
                     <li key={index}>{entry}</li>
                  ))}
                </ul>
          </div>
          </div>
        </div>
      </div>
    </div>
    
  );
  
};




export default Vortexdownload;


